'use strict';

// Constructor
var Overlay = function() {

  var self = this;

  self.config = {
    'overlay'  :  $('.overlay')
  }

  var $overlay = self.config.overlay;

  self.showOverlay = function() {
    if (! $overlay.hasClass('is-visible') && ! $overlay.hasClass('velocity-animating')) {
      $overlay
        .addClass('is-visible')
        .velocity('fadeIn',{
          duration: 200
        });
    }
  }

  self.hideOverlay = function() {
    if (! $overlay.hasClass('velocity-animating')) {
      $overlay
        .removeClass('is-visible')
        .velocity('fadeOut',{
          duration: 200
        });
    }
  }
};

module.exports = Overlay;
